// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3jgv8","colMin":"styles_colMin__1pOEg","colCheckbox":"styles_colCheckbox__p83EV"};